// chartjs-plugin-annotation must be imported before any Chart.js usage
import 'chartjs-plugin-annotation'

import { Provider } from 'react-redux'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment }        from '@mui/x-date-pickers/AdapterMoment'
import { store } from './store/store'
import App from './App'

export default function ActivityKPIDashboard() {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <Provider store={store}>
        <App />
      </Provider>
    </LocalizationProvider>
  )
}